

let serviceRootUrl = window.location.href.toLowerCase().includes("localhost")
? "https://apis-sandbox.intel.com/sc/tms/tender/v1/tender-dataset"
: window.location.href.toLowerCase().includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
? "https://apis-stage.intel.com/sc/tms/tender/v1/tender-dataset"
: window.location.href.toLowerCase().includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
? "https://apis-sandbox.intel.com/sc/tms/tender/v1/tender-dataset"
: window.location.href.toLowerCase().includes("https://transportationcons.intel.com") ||
  window.location.href.toLowerCase().includes("https://tmspreprod-portal.intel.com") ||
  window.location.href.toLowerCase().includes("https://transportation-preprod.intel.com")
? "https://apis-sandbox.intel.com/sc/tms/tender/v1/tender-dataset"
: window.location.href.toLowerCase().includes("https://transportation.intel.com") ||
  window.location.href.toLowerCase().includes("https://tms-portal.intel.com")
? "https://apis.intel.com/sc/tms/tender/v1/tender-dataset"
: "";

  let siteminderUrlData = window.location.href.toLowerCase().includes("localhost")
	? "https://sfederationpreprod.intel.com/federation/Entitlement_Warranty_Dev.asp"
	: window.location.href.toLowerCase().includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
	? "https://sfederationpreprod.intel.com/federation/Entitlement_Warranty_Dev.asp"
	: window.location.href.toLowerCase().includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
	? "https://sfederationpreprod.intel.com/federation/Entitlement_Warranty.asp"
	: window.location.href.toLowerCase().includes("https://transportationcons.intel.com") ||
    window.location.href.toLowerCase().includes("https://tmspreprod-portal.intel.com") ||
    window.location.href.toLowerCase().includes("https://transportation-preprod.intel.com")
	? "https://sfederationpreprod.intel.com/federation/Entitlement_Warranty.asp?RelayState=10912"
  : window.location.href.toLowerCase().includes("https://transportation.intel.com") ||
    window.location.href.toLowerCase().includes("https://tms-portal.intel.com")
	? "https://sfederation.intel.com/federation/Entitlement_Warranty.asp?RelayState=10912"
	: "";
 

  
const rootConstants = {

    serviceHeaders: {
        headers: {
          "Authorization": `Bearer ${sessionStorage.getItem("accessToken")}`,
          "Content-Type": "application/json",
         },
        withCredentials: true,
    
        responseType: 'json',
    
        mode: "no-cors",
      },
                serviceRoot: serviceRootUrl,
         siteMinderUrl : siteminderUrlData
    }
    

 
 


    export default rootConstants;